import React from "react";
import ct from "class-types.macro";
import LoginLink from "../LoginLink";
import ChatLink from "../ChatLink";

function MapOverride({
  productListingView,
  enabled,
}: {
  productListingView?: string;
  enabled: boolean;
}) {
  return (
    <p
      className={ct(
        "font-semibold",
        "text-xs",
        "leading-none",
        "mb-2",
        "text-gray-800",
        productListingView === "list"
          ? ct("m-0", "mt-1", "p-0", "pb-1", "xs:text-center")
          : ct("mb-0", "p-0", "pt-1", "text-center")
      )}
    >
      {enabled ? (
        <>
          {"Contact us or "}
          <LoginLink>login</LoginLink>
          <br />
          {" for pricing"}
        </>
      ) : (
        <>Contact us for pricing</>
      )}
      <ChatLink productListingView={productListingView} />
    </p>
  );
}

export default MapOverride;
